import { VALIDATE_UTILS } from '@widergy/web-utils';

import { FIELD_RADIO } from 'constants/userForms';
import { message } from 'utils/stringUtils';

const questionMapper = (question, position) => ({
  id: position,
  type: FIELD_RADIO,
  order: position,
  title: question.question,
  key: question.question,
  field_options: question.answers.map((answer, index) => ({
    id: index,
    name: answer.answer,
    value: answer.answer,
    order: index,
    correct: answer.correct
  })),
  validate: [VALIDATE_UTILS.required(message('Translation:fieldRequired'))]
});

export default questionMapper;
